(function () {
  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-track-cta]');
    if (!target) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'cta_click',
      cta_name: target.dataset.ctaName || '',
      cta_label: target.dataset.ctaLabel || (target.textContent || '').trim(),
      cta_context: target.dataset.ctaContext || '',
      cta_url: target.getAttribute('href') || '',
      page_path: window.location.pathname || '',
    });
  });
})();
